// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";

import axios from "axios";
import VueAxios from "vue-axios";
let axiosInst = axios.create({
  baseURL: process.env.BACKEND_URL
});
Vue.use(VueAxios, axiosInst);

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBhShAHmupkLhbQRDPNvuJjZ3zRHYjEvU4",
    libraries: "places" // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});
import GmapCluster from "vue2-google-maps/dist/components/cluster"; // replace src with dist if you have Babel issues
Vue.component("GmapCluster", GmapCluster);

import VueTimers from "vue-timers";
Vue.use(VueTimers);

import linkify from "vue-linkify";
Vue.directive("linkified", linkify);

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);

import Vuex from "vuex";
Vue.use(Vuex);

import VuexGeolocation from "vuex-geolocation";

import store from "@/store";

const vuexGeolocation = VuexGeolocation.sync(store, {
  autoWatch: store.state.player.optedIn
});
Vue.use(vuexGeolocation);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  store: store
});



// WEBPACK FOOTER //
// ./src/main.js